module.exports = __webpack_public_path__ + "img/dsci0011.7a21c7a0.jpg";